<template>
  <div class="solid-table">
    <el-table :data="tableData">
      <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :type="col.type"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const COLUMNS = [
  {
    unit: 'MW',
    name: '装机容量',
    value: 'cap'
  },
  {
    unit: 'MWh',
    name: '年上网电量',
    value: 'energyOngrid'
  },
  {
    unit: '万元',
    name: '总投资',
    value: 'totalInvest'
  },
  {
    unit: '万元',
    name: '建设期利息',
    value: 'constructionInterest'
  },
  {
    unit: '万元',
    name: '流动资金',
    value: 'fluid'
  },
  {
    unit: '万元',
    name: '销售收入总额（不含增值税）',
    value: 'operatingIncome'
  },
  {
    unit: '万元',
    name: '总成本费用',
    value: 'totalCost'
  },
  {
    unit: '万元',
    name: '销售税金附加总额',
    value: 'operatingTaxAdd'
  },
  {
    unit: '万元',
    name: '发电利润总额',
    value: 'totalProfit'
  },
  {
    unit: '元/kWh',
    name: '经营期平均电价（不含增值税）',
    value: 'priceWithout'
  },
  {
    unit: '元/kWh',
    name: '经营期平均电价（含增值税）',
    value: 'priceWith'
  },
  {
    unit: '年',
    name: '项目投资回收期（所得税前）',
    value: 'picfPbpBefore'
  },
  {
    unit: '年',
    name: '项目投资回收期（所得税后）',
    value: 'picfPbpAfter'
  },
  {
    unit: '%',
    name: '项目投资财务内部收益率（所得税前）',
    value: 'picfIrrBefore'
  },
  {
    unit: '%',
    name: '项目投资财务内部收益率（所得税后）',
    value: 'picfIrrAfter'
  },
  {
    unit: '万元',
    name: '项目投资财务净现值（所得税前）',
    value: 'picfNpvBefore'
  },
  {
    unit: '万元',
    name: '项目投资财务净现值（所得税后）',
    value: 'picfNpvAfter'
  },
  {
    unit: '%',
    name: '资本金财务内部收益率',
    value: 'cfopcIrr'
  },
  {
    unit: '万元',
    name: '资本金财务净现值',
    value: 'cfopcNpv'
  },
  {
    unit: '%',
    name: '总投资收益率（ROI）',
    value: 'roi'
  },
  {
    unit: '%',
    name: '投资利税率',
    value: 'profitTaxInvestmentRatio'
  },
  {
    unit: '%',
    name: '项目资本金净利润率（ROE）',
    value: 'roe'
  },
  {
    unit: '%',
    name: '资产负债率（最大值）',
    value: 'loar'
  },
  {
    unit: '%',
    name: '盈亏平衡点（生产能力利用率）',
    value: 'bepCapacityUtilization'
  },
  {
    unit: 'MWh',
    name: '盈亏平衡点（年产量）',
    value: 'bepAnnualOutput'
  },
  {
    unit: '万元',
    name: '纳税总额',
    value: 'avergeProfitTax'
  },
  {
    unit: '元/kWh',
    name: 'LCOE',
    value: 'lcoe'
  }
];
export default {
  props: {
    eco: Object
  },
  data() {
    return {};
  },
  computed: {
    columns() {
      if (!this.eco) return [];
      const cols = [
        {
          label: '序号',
          prop: 'index',
          type: 'index'
        },
        {
          label: '指标',
          prop: 'name'
        },
        {
          label: '单位',
          prop: 'unit'
        },
        {
          label: '经评',
          prop: 'value'
        }
      ];
      return cols;
    },
    tableData() {
      if (!this.eco) return [];
      return COLUMNS.map(col => {
        const row = {
          ...col,
          value: this.eco[col.value]
        };
        return row;
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
